module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-starL-3429c8397c0da5bd7c1fb628d75e64e6.png";